import '../../styles/modales.css';
import React, { useEffect, useState } from "react";
import Navbar from "../../navbar/navbar";
import Sidebar from "../../navbar/sidebar";
import { Alert, Col, Container, Row} 
from "react-bootstrap";
import {
  BsFileEarmarkMedicalFill,
  BsFillExclamationTriangleFill,
  BsFillExclamationDiamondFill,
  BsFillShieldFill,
  BsClipboardCheckFill,
  BsFileEarmarkXFill,
} from "react-icons/bs";


import { getAllActas } from '../../services/apiService';
import "../../App.css"
import "../../App.css"


export default function HomeComponent() {
  document.title = "Actas Circunstanciadas";


  const fecha = new Date();

  // Opciones para formatear la fecha
  const opciones = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  // Formatear la fecha según las opciones
  const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

  const [actaLevantamiento, setActaLevantamiento] = useState();
  const [actaApercibimiento, setActaApercibimiento] = useState();
  const [actaAmonestacion, setActaAmonestacion] = useState();
  const [actaPas, setActaPas] = useState();
  const [actaDTR, setActaDTR] = useState();
  const [actaSuspencion, setActaSuspencion] = useState();



  const getData = async (event) => {
    try {
      let response;
      response = await getAllActas(
        
      )
      setActaLevantamiento(response.Estado_Levantamiento);
      setActaApercibimiento(response.Estado_Apercibimiento);
      setActaAmonestacion(response.Estado_Amonestacion);
      setActaPas(response.Estado_PAS);
      setActaDTR(response.Estado_DTR);
      setActaSuspencion(response.Estado_Suspencion);

    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line 
  }, [

  ]);



  return (
    <div className="flex">
      <Sidebar />
      <div className="content w-100 cont">
        <Navbar />
        <div>
          <Container>
            <p className="nocolor text-center mediumtext">&zwnj;</p>
            <Row>
              <h2 className="text-center">
                <strong>
                  Bienvenido/a al Sistema de Actas Circunstanciadas
                </strong>
                <p>{fechaFormateada}</p>
              </h2>
            </Row>
            <p className="nocolor text-center mediumtext">&zwnj;</p>
            <Row>
              <Col>
                <Alert className="levantamiento-alert">
                  <Alert.Heading className="text-center">
                    <h2>
                      <BsFileEarmarkMedicalFill className='text-white' />

                      <br />
                    </h2>
                    <b className='text-white'>Actas en levantamiento</b>
                    <br />
                    <b className='text-black'>{actaLevantamiento}</b>
                  </Alert.Heading>
                </Alert>
              </Col>
              <Col>
                <Alert className="apercibimiento-alert">
                  <Alert.Heading className="text-center">
                    <h2>
                      <BsFillExclamationTriangleFill className='text-white' />
                      <br />
                    </h2>
                    <b className='text-white'>Actas en apercibimiento</b>
                    <br />
                    <b className='text-black'>{actaApercibimiento}</b>
                  </Alert.Heading>
                </Alert>
              </Col>
              <Col>
                <Alert className="amonestacion-alert">
                  <Alert.Heading className="text-center">
                    <h2>
                      <BsFillExclamationDiamondFill className='text-white' />
                      <br />
                    </h2>
                    <b className='text-white'>Actas en amonestación</b>
                    <br />
                    <b className='text-black'>{actaAmonestacion}</b>
                  </Alert.Heading>
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col>
                <Alert className="pas-alert">
                  <Alert.Heading className="text-center">
                    <h2>
                      <BsFillShieldFill className='text-white' />
                      <br />
                    </h2>
                    <b className='text-white'>Actas en PAS:</b>

                    <br />
                    <b className='text-black'>{actaPas}</b>
                  </Alert.Heading>
                </Alert>
              </Col>
              <Col>
                <Alert className="dtr-alert">
                  <Alert.Heading className="text-center">
                    <h2>
                      <BsClipboardCheckFill className='text-white' />
                      <br />
                    </h2>
                    <b className='text-white'>Actas en DTR</b>

                    <br />
                    <b className='text-black'>{actaDTR}</b>
                  </Alert.Heading>
                </Alert>
              </Col>
              <Col>
                <Alert className="suspension-alert">
                  <Alert.Heading className="text-center">
                    <h2>
                      <BsFileEarmarkXFill className='text-white' />
                      <br />
                    </h2>
                    <b className='text-white'>Actas en Suspensión</b>
                    <br />
                    <b className='text-black'>{actaSuspencion}</b>
                  </Alert.Heading>
                </Alert>
              </Col>
            </Row>
          </Container>
        </div>




        

      </div>
    </div>

  );
}
